import React from "react";
import styled, { keyframes } from "styled-components";

const StyledLiveEventSection = styled.section`
  position: fixed;
  left: 0;
  right: 0;
  z-index: 9999;
  background-color: #7f7f7f;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;

  a {
    display: flex;
    width: 100%;
    text-align: center;
    justify-content: center;
    gap: 12px;

    p {
      color: #ffffff;
      font-size: 12px;
      font-weight: 400;
      margin: 0;
      padding: 0;
      letter-spacing: 1.2px;
    }
  }
`;

// Define keyframes for fade-in and fade-out animation
const fadeInOut = keyframes`
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;

// Styled component for the SVG with fade-in and fade-out animation
const StyledPlayButton = styled.svg`
  width: 25px;
  height: 25px;
  cursor: pointer;
  animation: ${fadeInOut} 2s infinite; /* Infinite looping of fade-in and fade-out over 2 seconds */
`;

export default function LiveEvent() {
  return (
    <StyledLiveEventSection>
      <a href="https://example.com" aria-label="Live Event Link">
        {/* Add href and aria-label */}
        <p>Let see our live event </p>
        <StyledPlayButton
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 21.5 21.5"
    >
      <path
        id="Path_238"
        data-name="Path 238"
        d="M9.12,7.26v9.48c0,.19.16.32.29.23l7.36-4.74a.3.3,0,0,0,0-.46L9.41,7C9.28,6.94,9.12,7.07,9.12,7.26Z"
        transform="translate(-1.25 -1.25)"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        fillRule="evenodd"
      />
      <circle
        id="Ellipse_67"
        data-name="Ellipse 67"
        cx="10"
        cy="10"
        r="10"
        transform="translate(0.75 0.75)"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </StyledPlayButton>
      </a>
    </StyledLiveEventSection>
  );
}
